module.exports = __webpack_public_path__ + "static/media/lehotsky.39d864f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/lehotsky.jpg
// module id = 550
// module chunks = 0